<template>
  <div class="bespread-wrap module-layer3">
    <div class="screen-container">
      <img
        src="../../assets/img/layer3/cha2.png"
        alt=""
        srcset=""
        class="cha-r-b"
      />
      <div class="kv-content">
        <img
          src="../../assets/img/layer3/title.png"
          alt=""
          srcset=""
          class="title"
        />
        <div class="frame">
          <swiper :options="kvOptions" ref="kvOptions">
            <swiper-slide v-for="(item, idx) in kvList" :key="idx">
              <img :src="item" class="info" />
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <div
            class="swiper-pagination swiper-pagination-kv cursor"
            :class="[nextShow ? '' : 'swiperNoSwiping']"
            slot="pagination"
          ></div>
        </div>
        <img
          src="../../assets/img/layer3/cha.png"
          alt=""
          srcset=""
          class="cha-cat"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      kvList: [
        require("../../assets/img/layer3/1.jpg"),
        require("../../assets/img/layer3/2.jpg"),
        require("../../assets/img/layer3/3.jpg"),
        require("../../assets/img/layer3/4.jpg"),
        require("../../assets/img/layer3/5.jpg")
      ],

      nextShow: true,
      kvOptions: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination-kv",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.module-layer3 {
  background-image: url("../../assets/img/layer3/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .screen-container {
    width: 100%;
    position: relative;
    .cha-r-b {
      position: absolute;
      bottom: -10%;
      right: 0;
      height: 778px;
      width: auto;
    }
    .kv-content {
      position: absolute;
      left: 50%;
      top: 1vw;
      transform: translate(-50%, 0);
      width: 950px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .title {
        width: auto;
        height: 260px;
      }
      .frame {
        background-image: url("../../assets/img/layer3/frame.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        width: 853px;
        height: 522px;

        .info {
          width: 760px;
          height: auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        // 菜单
        .swiper-slide {
          overflow: hidden;
        }
        .swiper-button-prev:after {
          display: none;
        }

        .swiper-button-next:after {
          display: none;
        }

        .swiper-button-prev {
          background: url("../../assets/img/layer3/prev.png") no-repeat top;
          background-size: 100% 100%;
          width: 49px;
          height: 53px;
          top: 12vw;
          left: -2vw;
        }

        .swiper-button-next {
          background: url("../../assets/img/layer3/next.png") no-repeat top;
          background-size: 100% 100%;
          width: 49px;
          height: 53px;
          top: 12vw;
          right: -2vw;
        }

        /deep/ .swiper-pagination-kv {
          position: absolute;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1vw;
          left: 50%;
          transform: translateX(-50%);
          cursor: pointer;
          .custom-bullet {
            display: inline-block;
            width: 23px;
            height: 21px;
            background: url("../../assets/img/layer3/media.png");
             background-size: 100% 100%;
          }

          .custom-bullet-active {
            width: 23px;
            height: 21px;
            background: url("../../assets/img/layer3/media-active.png")
              no-repeat top;
            background-size: 100% 100%;
          }
        }
      }
      .cha-cat {
        width: 177px;
        height: auto;
        position: absolute;
        left: -8vw;
        bottom: -2vw;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer3 {
     .kv-content {
      top: 5vw !important;
     }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer3 {
     .kv-content {
      top: 5vw !important;
     }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer3.vue